export default __webpack_public_path__ + "static/media/bg7.784b6fcb.jpg";